export default "__VITE_ASSET__1d9bbe6e__"